export const CREDIT_CARD_FIELDS = {
  CARD_NAME: 'cardName',
  CARD_PROVIDER: 'cardProvider',
  CARD_NUMBER: 'cardNumber',
  CARD_EXPIRATION_YEAR: 'cardExpYear',
  CARD_EXPIRATION_MONTH: 'cardExpMo',
  CVV: 'cvv',
};

export const CREDIT_CARD_PROVIDERS = {
  AMERICAN_EXPRESS: 'americanExpress',
  VISA: 'visa',
  MASTERCARD: 'mastercard',
  DISCOVER: 'discover',
  OTHER: 'unknown',
};

export const MONTHS = [...Array(12)].map((_, index) => ({
  index,
  value: index + 1,
}));
